module.exports = __webpack_public_path__ + "static/favicon-32x32-650df895ce4378f9dabc0a0d3c1374b0.png";